import { IBuilding } from '../building';
import { ISuite } from './suite';

export interface IVehicle {
    id?: number;
    brand: string;
    building: number|IBuilding;
    color: string;
    licensePlate: string;
    model: string;
    note: string;
    owner: any;
    ownerName: any;
    suite?: number|ISuite;
    year: string;
    moveOutDate: string;
}

export class Vehicle implements IVehicle {
    id = null;
    brand = '';
    building = null;
    color = '';
    licensePlate = '';
    model = '';
    note = '';
    owner = null;
    ownerName: any;
    suite = null;
    year = '';
    moveOutDate = null;

    constructor(vehicle: Partial<IVehicle> = {}) {
        Object.assign(this, vehicle);
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/building/vehicle.ts